import React from "react";

import { Agent, UpdateAgentDto } from "../../types/app.types";
import { colorToHex, hexToHSL } from "../../helpers/general_helpers";

interface AgentListProps {
  agents: Agent[];
  onUpdateAgent: (id: number, dto: UpdateAgentDto) => Promise<void>;
  onDeleteAgent: (id: number) => Promise<void>;
}

export const AgentList: React.FC<AgentListProps> = ({
  agents,
  onUpdateAgent,
  onDeleteAgent,
}) => {
  const handleColorChange = (id: number, hexColor: string) => {
    onUpdateAgent(id, { color: hexToHSL(hexColor) });
  };

  const sortedAgents = [...agents].sort((a, b) => {
    if (a.name === "ООО КоДрайв") return -1;
    if (b.name === "ООО КоДрайв") return 1;
    return 0;
  });

  return (
    <div className="agents-card">
      <h2 className="agents-card-title">Список агентів - {agents.length}</h2>
      <div className="agents-list">
        <div className="agents-list-header">
          <div className="agent-name-header">Назва</div>
          <div className="agent-color-header">Колір</div>
          <div className="agent-actions-header">Дії</div>
        </div>
        {sortedAgents.map((agent) => (
          <div key={agent.id} className="agent-row">
            <input
              type="text"
              defaultValue={agent.name}
              onBlur={(e) => onUpdateAgent(agent.id, { name: e.target.value })}
              className="agent-input"
            />
            <div className="color-input-wrapper">
              <input
                type="color"
                value={colorToHex(agent.color)}
                onChange={(e) => handleColorChange(agent.id, e.target.value)}
                className="agent-color-input"
                title="Змінити колір агента"
              />
            </div>
            <button
              onClick={() => onDeleteAgent(agent.id)}
              className="delete-agent-btn"
              title="Видалити агента"
            >
              🗑️
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
